import React from 'react';
import cn from 'classname';
import _find from 'lodash/find';
import _pick from 'lodash/pick';
import _get from 'lodash/get';
import EditField from '../forms/edit-payout-requests-form-value/main';

const COMMENT_LENGTH_LIMIT = 30;
const isEverad = process.env.CPA_ENV === 'everad';

class Row extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		const {
			row, approveRequest, rejectRequest, acceptRequest, can, requestReview, index, remove, toggleEditForm,
			markRisked, table: { payoutMatrix }
		} = this.props;

		const isLessPayout = Number(row.current_payout) > (Number(row.payout_decision) || Number(row.amount));

		const recommendedPayout = _find(payoutMatrix, _pick(row, ['niche', 'sale_model', 'country_id']));

		const recommendedPayoutMin = _get(recommendedPayout, 'amount', 0);
		const recommendedPayoutMax = _get(recommendedPayout, 'max_amount', 0);

		const recommendedPayoutString = recommendedPayoutMin
			? `${Number(recommendedPayoutMin)} $ ${recommendedPayoutMax ? ` - ${Number(recommendedPayoutMax)} $` : ''}`
			: '';

		const isDeclineVisible = 	row.status === 'review' &&
			can('payout_requests_review') &&
			(!row.is_risk || isEverad);

		return (
			<tr className={cn({
				'modify-background': !!(index % 2),
				'payout-less': isLessPayout && !!row.amount,
				'payout-agreed': row.status === 'agreed',
				'payout-rejected': row.status === 'rejected',
				'was-reviewed': !!row.reviewed_at && row.status === 'review'
			})}>
				<td>
					<p>{row.id}</p>
					<p className="margin-top-5">
						{row.created_at_date}
					</p>
					<p className="margin-top-5">
						{row.created_at_time}
					</p>
					<p className="margin-top-5">
						{row.is_traffic_scaling && 'Traff scale payout!'}
					</p>
				</td>
				<td>{row.manager}</td>
				<td className="aff-col">
					<div>
						<p className="margin-top-5">
							{
								can('payout_requests_review') &&
								isEverad &&
								<span className={cn('profile-logo-icon-rocket margin-right-5', {
									'profile-logo-icon-rocket-inactive': row.has_activity_in_rocket === false,
									'profile-logo-icon-rocket-active': row.has_activity_in_rocket === true
								})}
								/>
							}
							{row.affiliate_id} {row.is_resale && '(R)'}
						</p>
						<p className="margin-top-5">{row.offer}</p>
						<p className="margin-top-5">{row.country}</p>
					</div>
				</td>
				<td className="text-center short-col have-traf-col">{row.maxDailyLeads}</td>
				<td className="text-center short-col have-traf-col">{row.has_conversions ? '✔' : '-'}</td>
				<td>
					{row.sid ? `${row.sid} ${row.sid_type ? `(${row.sid_type})` : ''} & ` : ''}  {row.campaign_id}
				</td>
				<td className="short-col">{Number(row.current_payout)} $</td>
				<td className="text-center short-col">
					{
						row.amount === null ? 'Max' : <span className="margin-right-10">{Number(row.amount)} $</span>
					}
				</td>
				<td className="short-col">{Number(row.garant_percent)}</td>
				<td className="text-center">{row.traffic_source}</td>
				<td className="text-center short-col">{ Number(row.planned_volume) ||  '-'}</td>
				{
					isEverad && can('payout_requests_review') &&
					<td className="text-center short-col">{recommendedPayoutString}</td>
				}
				<td className={cn({ 'analitic-cell': can('payout_requests_review'), 'text-center editable-cell': true })}>
					<div
						className={cn({
							'display-flex': true,
							'justify-content-between': can('payout_requests_review'),
							'flex-center': !can('payout_requests_review')
						})}
					>
						<span className="margin-right-10">
							{Number(row.payout_decision) || '-'}
						</span>
					</div>
					<EditField
						form={`payout-requests-edit-field-${index}-payout_decision`}
						{...this.props}
						fieldName="payout_decision"
						canBeEdited={can('payout_requests_review')}
						initialValues={{['payout_decision']: row['payout_decision']}}
						enableReinitialize={true}
					/>
				</td>
				<td className={cn({ 'analitic-cell': can('payout_requests_review'), 'text-center editable-cell': true })}>
					<div
						className={cn({
							'display-flex': true,
							'justify-content-between': can('payout_requests_review'),
							'flex-center': !can('payout_requests_review')
						})}
					>
						<span>{!row.granted_volume && !row.has_traffic ? 50 : (Number(row.granted_volume) || '-')}</span>
					</div>
					<EditField
						form={`payout-requests-edit-field-${index}-granted_volume`}
						{...this.props}
						fieldName="granted_volume"
						canBeEdited={can('payout_requests_review')}
						initialValues={{['granted_volume']: row['granted_volume']}}
						enableReinitialize={true}
					/>
				</td>
				<td
					className={cn({
						'text-center comment-cell editable-cell': true,
						'has-long-comment': row.comment && row.comment.length > COMMENT_LENGTH_LIMIT
					})}
				>
					<div
						className={cn({
							'display-flex padding-0-15': true,
							'justify-content-between': can('payout_requests_manager_role'),
							'flex-center': !can('payout_requests_manager_role')
						})}
					>
						<span className="margin-right-10 word-break-all">
							{row.comment && row.comment.slice(0, COMMENT_LENGTH_LIMIT)
								.split('\n')
								.map((val, id) => <p key={id}> {val} </p>)
							}
							{!!row.comment && row.comment.length > COMMENT_LENGTH_LIMIT && '...'}
						</span>
					</div>

					<EditField
						form={`payout-requests-edit-field-${index}-comment`}
						{...this.props}
						fieldName="comment"
						canBeEdited={can('payout_requests_manager_role')}
						isNeedUseTextArea={true}
						initialValues={{['comment']: row['comment']}}
						enableReinitialize={true}
					/>
				</td>
				<td
					className={cn({
						'analitic-cell': can('payout_requests_review'),
						'text-center comment-cell editable-cell': true,
						'has-long-comment': row.analytic_comment && row.analytic_comment.length > COMMENT_LENGTH_LIMIT
					})}
					onMouseEnter={this.toggleAnalCommentOpen}
					onMouseLeave={this.toggleAnalCommentOpen}
				>
					<div
						className={cn({
							'display-flex padding-0-15': true,
							'justify-content-between': can('payout_requests_review'),
							'flex-center': !can('payout_requests_review')
						})}
					>
						<span className="margin-right-10 word-break-all">
							{
								row.analytic_comment && row.analytic_comment.slice(0, COMMENT_LENGTH_LIMIT)
									.split('\n')
									.map((val, id) => <p key={id}> {val} </p>)
							}
							{!!row.analytic_comment && row.analytic_comment.length > COMMENT_LENGTH_LIMIT && '...'}
						</span>
					</div>
					<EditField
						form={`payout-requests-edit-field-${index}-analytic_comment`}
						{...this.props}
						fieldName="analytic_comment"
						canBeEdited={can('payout_requests_review')}
						isNeedUseTextArea={true}
						initialValues={{['analytic_comment']: row['analytic_comment']}}
						enableReinitialize={true}
					/>
				</td>
				<td>{row.status}</td>
				<td className="actions">
					{
						row.status === 'review' &&
						can('payout_requests_review') &&
						<div className="payout-request-table-action-button-container confirm-button-container">
							<button
								className="confirm-btn green-btn-1"
								onClick={approveRequest.bind(null, row.id)}
							>
								Payout Approval
							</button>
						</div>
					}
					{
						isDeclineVisible &&
						<div className="payout-request-table-action-button-container reject-button-container">
							<button
								className="reject-btn red-btn-1"
								onClick={rejectRequest.bind(null, row.id)}
							>
								Decline
							</button>
						</div>
					}
					{
						row.status === 'agreed' &&
						can('payout_requests_confirm') &&
						<div className="payout-request-table-action-button-container confirm-button-container">
							<button
								className="confirm-btn green-btn-1"
								onClick={acceptRequest.bind(null, row.id)}
							>
								Confirm payout
							</button>
						</div>
					}
					{
						row.status !== 'review' &&
						can('payout_requests_manager_role') &&
						<div className="payout-request-table-action-button-container confirm-button-container">
							<button
								className="refresh-btn orange-btn-1"
								onClick={requestReview.bind(null, row.id)}
							>
								<span className="margin-top-5 margin-left-5">
									Request review
								</span>
							</button>
						</div>
					}
					{
						(can('payout_requests_review') || can('payout_requests_manager_role')) &&
						(row.status === 'review' || row.status === 'rejected') &&
						<div className="payout-request-table-action-button-container confirm-button-container">
							<a
								className="action_delete"
								href="#"
								onClick={e => {
									e.preventDefault();
									remove(row.id);
								}}
							>
							</a>
						</div>
					}
					{
						(can('payout_requests_review') || can('payout_requests_manager_role')) &&
						row.status === 'agreed' &&
						<div
							className="payout-request-table-action-button-container confirm-button-container"
							onClick={e => {
								e.preventDefault();
								remove(row.id);
							}}
						>
							<a
								className="action_delete"
								href="#"
							>
							</a>
						</div>
					}
					{
						can('payout_requests_review') &&
						<div className="payout-request-table-action-button-container flex-center">
							{
								row.status === 'review' &&
								<a
									className="action_edit margin-10"
									href="#"
									onClick={e => {
										e.preventDefault();
										toggleEditForm(row.id);
									}}
								></a>
							}
							<a
								className={row.is_risk ? 'action_mark_risked' : 'action_mark_risked_inactive'}
								href="#"
								onClick={e => {
									e.preventDefault();
									markRisked(row.id);
								}}
							>
							</a>
						</div>
					}
				</td>
			</tr>
		);
	}
}

export default Row;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-requests/row.js